<script setup>
/* eslint-disable */
import { usePreSportsStore } from '@/stores/pre_sports';
import { useSocketStore } from '@/stores/socket';
import { useSportPopularStore } from '@/stores/sport_popular';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useLaternaStore }  from '@/stores/laterna';
import FixtureCard from './sport_highlights/FixtureCard.vue'
import FeaturedFixture from '@/components/pre_sports/FeaturedFixture.vue';
import { useLiveSportsStore } from '@/stores/live_sports';
import _ from 'lodash';
import '@splidejs/vue-splide/css';

import { useRouter } from 'vue-router';

const preSportsStore = usePreSportsStore();
const socketStore = useSocketStore();
const sportPopularStore = useSportPopularStore();
const liveSportsStore = useLiveSportsStore();
const section_sports = ref([]);
const common_sports = ref([]);
const props = defineProps({
	section: {
		type: Object,
		required: true,
	},
})


const selectedSport = ref(null);
const router = useRouter();
const direction = ref(document.dir);
const options = ref({
	direction: direction,
	rewind: false,
	pagination: false,
	type: 'slide',
	perPage: 3,
	perMove: 1,
	arrows: true,
	autoWidth: true,
	breakpoints: {
		499: {
			perPage: 1,
			pagination: true,
		},
		767: {
			perPage: 2,
			pagination: true,
		},
		1400: {
			perPage: 2,
			pagination: false,
		},
		2560: {
			perPage: 3,
		}
	},
});

socketStore.getSocket.on('sportHighlights', (data) => {
	sportPopularStore.setPopularFixtures(data);
})

socketStore.getSocket.on('sportHighlightsUpdate', (data) => {
	sportPopularStore.updatePopularFixtures(data);
});


const goToSportHighlights = () => {
	router.push({ name: 'pre-sports-highlights', params: { sport_id: selectedSport.value.id } })
};

const joinSportHighlights = (oldSport, newSport) => {
	if (!newSport) return;
	socketStore.getSocket.emit('leave-sportHighlights');


	socketStore.getSocket.emit('join-sportHighlights', newSport.id);
};

function getCommonSports() {
	const ids = new Set(preSportsStore.preSports.map(item => item.id));
	common_sports.value = section_sports.value.filter(item => ids.has(item.id));

	return common_sports.value;
}

onMounted(async () => {
    section_sports.value = await useLaternaStore().fetchLandingSectionItems(props.section.id);
	selectedSport.value = getCommonSports()[0];
});

onUnmounted(() => {
	socketStore.getSocket.emit('leave-sportHighlights');
});

const changeSport = (sport) => {
	selectedSport.value = sport;
};

watch(() => preSportsStore.preSports, (newSports, oldSports) => {
	if (oldSports.length > 0) return;
	selectedSport.value = getCommonSports()[0];
}, {deep: true})

watch(() => selectedSport.value, (newSport, oldSport) => {
	joinSportHighlights(oldSport, newSport);
})

const filteredSports = computed(() => {
	return _.take(common_sports.value, 10);
});

const getTopFeaturedFixtures = computed(() => {
	let fixtures_count = 5;
	if (props.section.fixtures_count) fixtures_count = props.section.fixtures_count;
	return _.chain(sportPopularStore.popular_fixtures).orderBy(['sort','competition_weight', 'start_datetime', 'competition_region_name'], ['asc','desc', 'asc', 'asc']).take(fixtures_count).value();
});
</script>
<template>
	<div class="eee-eimai-div">

		<div class="container-sm">
			<div class="popular-games-bar">
				<div class="popular-left">
					<img v-if="props.section.media" :src="props.section.media?.path" class="popular-icon"/>
					<span class="popular-title">{{ section.title }}</span>
				</div>

				<div class="popular-right">
					<div class="sport-icons">
						<template  v-for="sport in filteredSports" :key="sport.id">
							<div @click="changeSport(sport)" class="highlight-sport">
								<svg v-if="selectedSport?.id == sport.id" class="normal-img"
									xmlns="http://www.w3.org/2000/svg"
									xml:space="preserve"
									version="1.1"
									style="width:28px; fill: none; stroke: var(--primary); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
									viewBox="0 0 30 25"
									xmlns:xlink="http://www.w3.org/1999/xlink">
									<use :xlink:href="liveSportsStore.liveSportSvg(sport.id) + '#svg3108'" stroke-width="1px"  />
								</svg>

								<svg v-else class="normal-img"
									xmlns="http://www.w3.org/2000/svg"
									xml:space="preserve"
									version="1.1"
									style="width:28px; fill: none; stroke: grey; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
									viewBox="0 0 30 25"
									xmlns:xlink="http://www.w3.org/1999/xlink">
									<use :xlink:href="liveSportsStore.liveSportSvg(sport.id) + '#svg3108'" stroke-width="1px"  />
								</svg>



							</div>
						</template>
					</div>

					<div class="view-all-desktop">
						<button @click="goToSportHighlights" class="view-all-btn">{{ $t('landing.view_all')}} </button>
					</div>
				</div>
			</div>

			<div class="iex">
				<div class="popular-games-bar-mobile">
					<div class="popular-left">
						<img v-if="props.section.media" :src="props.section.media?.path" class="popular-icon"/>
						<span class="popular-title">{{ section.title }}</span>
					</div>

					<div class="popular-right">
						<div class="view-all-desktop">
							<button @click="goToSportHighlights" class="view-all-btn">{{ $t('landing.view_all')}}</button>
						</div>
					</div>


				</div>
				<div class="popular-right">
					<div class="sport-icons">
						<template  v-for="sport in filteredSports" :key="sport.id">
							<div @click="changeSport(sport)" class="highlight-sport">
								<svg v-if="selectedSport?.id == sport.id" class="normal-img"
									xmlns="http://www.w3.org/2000/svg"
									xml:space="preserve"
									version="1.1"
									style="width:28px; fill: none; stroke: var(--primary); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
									viewBox="0 0 30 25"
									xmlns:xlink="http://www.w3.org/1999/xlink">
									<use :xlink:href="liveSportsStore.liveSportSvg(sport.id) + '#svg3108'" stroke-width="1px"  />
								</svg>

								<svg v-else class="normal-img"
									xmlns="http://www.w3.org/2000/svg"
									xml:space="preserve"
									version="1.1"
									style="width:28px; fill: none; stroke: grey; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
									viewBox="0 0 30 25"
									xmlns:xlink="http://www.w3.org/1999/xlink">
									<use :xlink:href="liveSportsStore.liveSportSvg(sport.id) + '#svg3108'" stroke-width="1px"  />
								</svg>
							</div>
						</template>
					</div>

				</div>
			</div>

			<div class="live-score-main">

				<div ref="live_now_slider_container_ref" class="league-slider-main">
					<div class="wrapper">
						<div class="hl-slider-inner league_slides-inner">
							<Splide :options="options">
								<SplideSlide v-for="(fixture, index) in getTopFeaturedFixtures" :key="index">
									<FixtureCard :fixture="fixture"/>
								</SplideSlide>
							</Splide>
						</div>
					</div>

				</div>
			</div>
			<!-- score slider card end-->
		</div>

	</div>
</template>
<style scoped>
.popular-left img {
    width: 40px;
}

.popular-games-bar-mobile {
	display:none;
}
.eee-eimai-div {
	margin-top: 20px;
}
.featured-bottom-mobile {
	display:none;
}
.live-score-main {
	overflow: hidden;
}
.league-slider-main .wrapper .league-slide-item {
	margin-right: 7px;
}
.league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrow:disabled) {
	display: none !important;
}

.league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--next) {
    right: 1em !important;
    display: flex;
}

.league-slider-main .wrapper .league_slides-inner :deep(.splide__arrows .splide__arrow--prev) {
	left: 1em !important;
    display: flex;
}





html[dir="rtl"] .league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrows .splide__arrow--prev) {
	/* rotate: 180deg; */
	/* right: -10px; */
	/* top: 35%; */
	display: flex;
	left: unset;
}

html[dir="rtl"] .league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrows .splide__arrow--next) {
	/* rotate: 180deg; */
	/* left: -10px; */
	/* top: 35%; */
	display: flex;
	right: unset;
}

@media screen and (min-width: 320px) and (max-width: 991px) {
	.league-silder {
		margin-bottom: 20px;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	html[dir="rtl"] .league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
		top: 30%;
	}

	html[dir="rtl"] .league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px;
		top: 30%;
	}
}
@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .league-slider-main .wrapper .hl-slider-inner :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}

@media screen and (min-width: 320px) and (max-width: 425px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 92vw;
	}
}

@media screen and (min-width: 426px) and (max-width: 499px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 85vw;
	}
}

@media screen and (min-width: 500px) and (max-width: 530px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 80vw;
	}
}

@media screen and (min-width: 531px) and (max-width: 708px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 47vw;
	}
}

@media screen and (min-width: 709px) and (max-width: 766px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 54.5vw;
	}
}

@media screen and (min-width: 767px) and (max-width: 991px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 48vw;
	}
}

@media screen and (min-width: 992px) and (max-width: 1018px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 37.5vw;
	}
}

@media screen and (min-width: 1019px) and (max-width: 1024px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 38vw;
	}
}

@media screen and (min-width: 1025px) and (max-width: 1041px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 35.5vw;
	}
}

@media screen and (min-width: 1042px) and (max-width: 1075px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 36vw;
	}
}

@media screen and (min-width: 1076px) and (max-width: 1119px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 36.5vw;
	}
}

@media screen and (min-width: 1120px) and (max-width: 1163px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 35vw;
	}
}

@media screen and (min-width: 1164px) and (max-width: 1210px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 33.5vw;
	}
}

@media screen and (min-width: 1211px) and (max-width: 1260px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 31vw;
	}
}

@media screen and (min-width: 1261px) and (max-width: 1270px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 31vw;
	}
}

@media screen and (min-width: 1271px) and (max-width: 1280px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 31vw;
	}
}

@media screen and (min-width: 1281px) and (max-width: 1281px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 30vw;
	}
}

@media screen and (min-width: 1282px) and (max-width: 1366px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 27vw;
	}
}

@media screen and (min-width: 1367px) and (max-width: 1400px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 27.5vw;
	}
}

@media screen and (min-width: 1401px) and (max-width: 1420px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 27.4vw;
	}
}

@media screen and (min-width: 1421px) and (max-width: 1430px) {
	.league-slider-main .wrapper .league-slide-item {
			width: 27.4vw;
	}
}

@media screen and (min-width: 1431px) and (max-width: 1460px) {
	.league-slider-main .wrapper .league-slide-item {
			width: 27.4vw;
	}
}

@media screen and (min-width: 1461px) and (max-width: 1500px) {
	.league-slider-main .wrapper .league-slide-item {
			width: 27.4vw;
	}
}

@media screen and (min-width: 1501px) and (max-width: 1540px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 25.5vw;
	}
}

@media screen and (min-width: 1541px) and (max-width: 1570px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 24.8vw
	}
}

@media screen and (min-width: 1571px) and (max-width: 1599px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 24.1vw;
	}
}

@media screen and (min-width: 1600px) and (max-width: 1620px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 23.8vw;
	}
}

@media screen and (min-width: 1621px) and (max-width: 1645px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 24vw;
	}
}

@media screen and (min-width: 1646px) and (max-width: 1679px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 24vw;
	}
}

@media screen and (min-width: 1680px) and (max-width: 1717px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 23.5vw;
	}
}

@media screen and (min-width: 1718px) and (max-width: 1755px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 22.8vw;
	}
}

@media screen and (min-width: 1756px) and (max-width: 1795px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 22.2vw;
	}
}

@media screen and (min-width: 1796) and (max-width: 1837px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 20.5vw;
	}
}

@media screen and (min-width: 1838px) and (max-width: 1880px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 20.8vw;
	}
}

@media screen and (min-width: 1881px) and (max-width: 1912px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 21vw;
	}
}

@media screen and (min-width: 1913px) and (max-width: 1930px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 21.2vw;
	}
}

@media screen and (min-width: 1931px) and (max-width: 1940px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 21vw;
	}
}

@media screen and (min-width: 1941px) and (max-width: 1999px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 21vw;
	}
}

@media screen and (min-width: 2000px) and (max-width: 2560px) {
	.league-slider-main .wrapper .league-slide-item {
		width: 15.8vw;
	}
}
.league-slider-main {
	width: 100%;
	position: relative;
	margin-top: 0px;
	min-height: 206px;
}

.league-slider-main .wrapper {
	overflow: visible;
	position: relative;
	width: 100%;
	z-index: 1;
}


/* View all button */
.view-all-btn {
	background: transparent;
	color: var(--white);
    border: 1px solid rgba(255, 255, 255, 0.85);
    border-radius: 5px;
	padding: 8px 20px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition:
		background-color 0.25s ease,
		box-shadow 0.25s ease,
		border-color 0.25s ease;
}

.view-all-btn:hover {
	background-color: rgba(255, 255, 255, 0.1);
	box-shadow: 0 0 10px rgba(255, 255, 255, 0.35);
	border-color: var(--white);
}

.view-all-btn:active {
	transform: scale(0.97);
}

.popular-games-bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-bottom: 10px;
	/* padding: 14px 20px; */
	/* background: linear-gradient(90deg, #0b1c28 0%, #0e2636 100%); */
	color: var(--white);
	border-bottom: 1px solid var(--secondary);
}

/* Left side */
.popular-left {
	display: flex;
	align-items: center;
	gap: 10px;
}

.popular-icon {
	font-size: 20px;
}

.popular-title {
	font-size: 22px;
	font-weight: 600;
	letter-spacing: 0.2px;
}

/* Right side */
.popular-right {
	display: flex;
	align-items: center;
	gap: 18px;
}

/* Sport icons */
.sport-icons {
	display: flex;
	gap: 10px;
}

.sport-icon {
	font-size: 20px;
	opacity: 0.85;
	cursor: pointer;
	transition: transform 0.2s ease, opacity 0.2s ease;
}

.sport-icon:hover {
	opacity: 1;
	transform: translateY(-2px);
}

.highlight-sport {
	cursor: pointer;
}

svg{
	height: 25px;
	max-width: 28px;
}

.iex {
		display:none;
	}
@media (max-width: 768px) {

.popular-games-bar {
	display: none;
}

	  .popular-left img {
        width: 25px;
    }

	.iex {
		display: grid;
		row-gap: 10px;
		padding-bottom: 10px;
	}

.popular-games-bar-mobile {
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: var(--white);
	border-bottom: 1px solid var(--secondary);
	padding-bottom: 10px;
}


    .popular-title[data-v-087529f8] {
        font-size: 20px;
        font-weight: 600;
        letter-spacing: 0.2px;
    }

    .view-all-btn {
        padding: 4px 10px;
        font-size: 12px;
    }

	.live-score-main {
		padding-top: 0px !important;
	}

.popular-right {
	justify-content: center;
}

  .popular-games-bar {
	flex-wrap: wrap;
	row-gap: 10px;
	justify-content: center;
  }

  .featured-bottom-mobile {
		display: flex;
		justify-content: center;
		margin-top: 12px;
	}

	.popular-left {
	gap: 3px;
}

/*
	.view-all-desktop {
		display:none;
	} */
}

:deep(.splide__pagination) {
	display: none !important;

}

:deep(.splide__pagination) .splide__track {
	overflow: unset !important;
	padding-right: 0px !important;
	padding-left: 0px !important;
}



.live-score-main {
	padding-top: 10px;
	padding-bottom: 0px;
}
</style>